import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

export type PasswordCheckKey = 'uppercase' | 'lowercase' | 'number' | 'symbol' | 'minLength';

@Component({
  selector: 'app-password-requirements',
  templateUrl: './password-requirements.component.html',
  styleUrls: ['./password-requirements.component.scss'],
})
export class PasswordRequirementsComponent implements OnInit {
  @Input() control!: AbstractControl | null;

  passwordRequirements: { label: string; key: PasswordCheckKey; icon: string }[] = [
    { label: '1 mayúscula', key: 'uppercase', icon: '../../../assets/icon/emptyPassword.svg' },
    { label: '1 minúscula', key: 'lowercase', icon: '../../../assets/icon/emptyPassword.svg' },
    { label: '1 número', key: 'number', icon: '../../../assets/icon/emptyPassword.svg' },
    { label: '1 signo', key: 'symbol', icon: '../../../assets/icon/emptyPassword.svg' },
    { label: '8 caracteres mínimo', key: 'minLength', icon: '../../../assets/icon/emptyPassword.svg' },
  ];

  passwordChecks: Record<PasswordCheckKey, boolean> = {
    uppercase: false,
    lowercase: false,
    number: false,
    symbol: false,
    minLength: false,
  };

  ngOnInit(): void {
    if (this.control) {
      this.control.valueChanges.subscribe((value: string) => {
        this.validatePasswordRequirements(value || '');
      });
    }
  }

  private validatePasswordRequirements(value: string): void {
    this.passwordChecks.uppercase = /[A-Z]/.test(value);
    this.passwordChecks.lowercase = /[a-z]/.test(value);
    this.passwordChecks.number = /\d/.test(value);
    this.passwordChecks.symbol = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    this.passwordChecks.minLength = value.length >= 8;

    this.passwordRequirements.forEach(req => {
      if (this.passwordChecks[req.key]) {
        req.icon = '../../../assets/icon/validPassword.svg';
      } else if (value.length === 0) {
        req.icon = '../../../assets/icon/emptyPassword.svg';
      } else {
        req.icon = '../../../assets/icon/invalidPassword.svg';
      }
    });
  }
}
